/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SiteSystemIsMotorised {
    Unknown = 0,
    No = 1,
    Yes = 2,
}
